import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()

    return appStore.isLoggedIn()
}

/*
 * Where to go after signing in. The guard sends somebody without a session to the login page
 * with the address they asked for in `redirect`, and this takes them back to it — but only to
 * an address inside this console, never to another site.
 */
export const safeRedirect = (value: unknown): string | null => {
    if (typeof value !== 'string') return null
    if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null
    if (value.startsWith('/login')) return null

    return value
}
